"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useButtonWithDialog = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const useDialogAnchorGlue_1 = require("./useDialogAnchorGlue");
function useButtonWithDialog({ testId, buttonProps, dialogProps }) {
    const { anchorRef, getAnchorClientRect, showDialog, hideDialog, showingDialog } = (0, useDialogAnchorGlue_1.useDialogAnchorGlue)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { ref: anchorRef },
            react_1.default.createElement(widgets_1.ButtonWidget, Object.assign({ testId: testId, onClick: showDialog, disabled: showingDialog || buttonProps.disabled }, buttonProps))),
        showingDialog && (react_1.default.createElement(widgets_1.DialogWidget, Object.assign({ testId: testId, getAnchorClientRect: getAnchorClientRect, handleGlassClick: hideDialog, onCloseRequest: hideDialog }, dialogProps)))));
}
exports.useButtonWithDialog = useButtonWithDialog;
//# sourceMappingURL=useButtonWithDialog.js.map